import React, { createContext, useReducer, useEffect } from "react";

// Router
import Router from "./router";
import Login from "./pages/login";

// Provider
import { Provider } from "react-redux";

// Store
import store from "./store";

import "./App.less";

import Loading from "./components/loading";

//import multilanguage library
import { withTranslation, useTranslation } from "react-i18next";

import { ApolloProvider } from "@apollo/react-hooks";

import apolloClient from "./services/apolloSetup";

import jwt from "jsonwebtoken";

export const AuthContext = createContext();

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
  entity_selected: null,
};

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN":
      localStorage.setItem("user", JSON.stringify(action.payload.user));
      localStorage.setItem("token", JSON.stringify(action.payload.token));
      localStorage.setItem("entity_selected", JSON.stringify(action.payload.entity_selected));
      return {
        ...state,
        isAuthenticated: true,
        user: action.payload.user,
        token: action.payload.token,
        entity_selected: action.payload.entity_selected,
      };
    case "LOGOUT":
      localStorage.clear();
      return {
        ...state,
        isAuthenticated: false,
        user: null,
        token: null,
        entity_selected: null,
      };
    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, initialState);

  //Use ready to wait language charge
  const { ready } = useTranslation();

  useEffect(() => {
    //Para el efecto dl horno
    localStorage.removeItem("furnaceTemp");

    const user = JSON.parse(localStorage.getItem("user") || null);
    const token = JSON.parse(localStorage.getItem("token"));
    const entity_selected = JSON.parse(localStorage.getItem("entity_selected"));

    var decodedToken = jwt.decode(token, { complete: true });

    var dateNow = new Date();
    const valid_token = decodedToken && decodedToken.payload.exp * 1000 > dateNow.getTime();

    if (user && valid_token && entity_selected) {
      dispatch({
        type: "LOGIN",
        payload: { user, token, entity_selected },
      });
    } else {
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      localStorage.removeItem("entity_selected");
    }
  }, []);

  return ready ? (
    <ApolloProvider client={apolloClient}>
      <AuthContext.Provider
        value={{
          state,
          dispatch,
        }}
      >
        <Provider store={store}>
          <div className="App">{!state.isAuthenticated ? <Login /> : <Router />}</div>
        </Provider>
      </AuthContext.Provider>
    </ApolloProvider>
  ) : (
    <Loading />
  );
}

export default withTranslation()(App);
